import { render } from "./CancelContract.vue?vue&type=template&id=82ffc37c"
import script from "./CancelContract.vue?vue&type=script&lang=js"
export * from "./CancelContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__